import { render, staticRenderFns } from "./GenericDateTime.vue?vue&type=template&id=40bb2ea2&scoped=true&"
import script from "./GenericDateTime.vue?vue&type=script&lang=js&"
export * from "./GenericDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb2ea2",
  null
  
)

export default component.exports